import {
  faChildReaching,
  faFloppyDisk,
  faXmark,
} from "@fortawesome/pro-solid-svg-icons";
import { Button, Stack } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

import {
  Divider,
  Grid,
  Icon,
  IconButton,
  TextField,
  Typography,
} from "@/components/ui-v2";

import { usePoserStore } from "../../../../state";
import { PoseData } from "../../../../types";

interface SidebarProps {
  poseData: PoseData;
  setPoseData: Dispatch<SetStateAction<PoseData>>;
  onUsePose: () => void;
  onSavePose: () => void;
}

export const Sidebar = (props: SidebarProps) => {
  const { poseData, setPoseData, onSavePose, onUsePose } = props;
  const { closePoseCreator } = usePoserStore();
  return (
    <Stack direction="column" sx={{ height: "100%" }}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography>{poseData.fileId ? "Edit Pose" : "Create Pose"}</Typography>
        <IconButton
          aria-label="Close"
          variant="primary"
          onClick={closePoseCreator}
        >
          <Icon icon={faXmark} />
        </IconButton>
      </Stack>
      <Divider />
      <Grid container spacing={2} sx={{ mt: 8 }}>
        <Grid item xs={12}>
          <TextField
            variant="filled"
            size="medium"
            value={poseData.name}
            label="Name"
            onChange={(e) =>
              setPoseData((prev) => ({
                ...prev,
                name: e.target.value,
                isDirty: true,
              }))
            }
            fullWidth
            InputProps={{
              placeholder: "Enter pose name",
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={onSavePose}
            loading={poseData.isSaving}
            disabled={!poseData.isDirty}
            startIcon={<Icon icon={faFloppyDisk} />}
            fullWidth
          >
            Save Pose
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={onUsePose}
            loading={poseData.isSaving}
            startIcon={<Icon icon={faChildReaching} />}
            fullWidth
          >
            Use Pose
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
};
